import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "gfu-project-rankings",
  role: "region",
  "aria-labelledby": "project-rankings-title"
}
const _hoisted_2 = {
  id: "project-rankings-title",
  class: "gfu-project-rankings__title"
}
const _hoisted_3 = { class: "gfu-project-rankings-selectors" }
const _hoisted_4 = {
  key: 0,
  class: "_grid _grid-cols-1"
}
const _hoisted_5 = {
  key: 1,
  class: "_grid _grid-cols-2--l _gap-6"
}
const _hoisted_6 = {
  key: 0,
  class: "_grid _grid-cols-1"
}
const _hoisted_7 = {
  key: 1,
  class: "_grid _grid-cols-2--l _gap-6"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_option_field = _resolveComponent("option-field")
  const _component_rankings_list = _resolveComponent("rankings-list")
  const _component_skeleton_ranking_list = _resolveComponent("skeleton-ranking-list")
  const _component_section_expander = _resolveComponent("section-expander")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "title")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_option_field, {
          modelValue: $data.model.period,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.period) = $event)),
          options: $options.timeSpanOptions,
          "display-name": _ctx.Resources.Homepage.RankingsTimeSpanSelectLabel,
          "label-class": "_sr-only",
          class: "gfu-project-rankings-selectors__option",
          "data-qa": "time-span-options"
        }, null, 8 /* PROPS */, ["modelValue", "options", "display-name"]),
        ($options.isTablet)
          ? (_openBlock(), _createBlock(_component_option_field, {
              key: 0,
              modelValue: $data.model.type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.model.type) = $event)),
              options: $options.rankingTypeOptions,
              "display-name": _ctx.Resources.Homepage.RankingsSortTypeSelectLabel,
              "label-class": "_sr-only",
              class: "gfu-project-rankings-selectors__option",
              "data-qa": "time-span-field"
            }, null, 8 /* PROPS */, ["modelValue", "options", "display-name"]))
          : _createCommentVNode("v-if", true),
        (!$options.isTablet)
          ? (_openBlock(), _createBlock(_component_option_field, {
              key: 1,
              modelValue: $data.model.projectCategoryID,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.model.projectCategoryID) = $event)),
              options: $options.categoryTypeOptions,
              "display-name": _ctx.Resources.Homepage.RankingsCategorySelectLabel,
              "show-placeholder": false,
              "label-class": "_sr-only",
              class: "gfu-project-rankings-selectors__option",
              "data-qa": "category-options"
            }, null, 8 /* PROPS */, ["modelValue", "options", "display-name"]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createVNode(_component_section_expander, {
      "aria-busy": !$data.isInitialized
    }, {
      default: _withCtx(() => [
        ($data.isInitialized)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              ($options.isTablet)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_rankings_list, {
                      items: $data.projects,
                      title: $options.mobileRankingTexts.title,
                      icon: $options.mobileRankingTexts.icon
                    }, null, 8 /* PROPS */, ["items", "title", "icon"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_rankings_list, {
                      items: $data.fundingRankingsList,
                      title: _ctx.Resources.Homepage.RankingsFundingCategoryOption,
                      icon: "money-bill-trend-up",
                      "data-qa": "ranking-list:Funding"
                    }, null, 8 /* PROPS */, ["items", "title"]),
                    _createVNode(_component_rankings_list, {
                      items: $data.audienceRankingsList,
                      title: _ctx.Resources.Homepage.RankingsAudienceCategoryOption,
                      icon: "users",
                      "data-qa": "ranking-list:Audience"
                    }, null, 8 /* PROPS */, ["items", "title"])
                  ]))
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              ($options.isTablet)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_skeleton_ranking_list)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_skeleton_ranking_list),
                    _createVNode(_component_skeleton_ranking_list)
                  ]))
            ], 64 /* STABLE_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["aria-busy"])
  ]))
}